import React, { useEffect, useState } from 'react'

import OwlCarousel from 'react-owl-carousel';
import 'owl.carousel/dist/assets/owl.carousel.css';
import 'owl.carousel/dist/assets/owl.theme.default.css'

import { getProduct } from '../Redux/ActionCreator/ProductActionCreator'
import { getCart, createCart } from '../Redux/ActionCreator/CartActionCreator'
import { getWishlist, createWishlist } from '../Redux/ActionCreator/WishlistActionCreator'

import { Link, useNavigate, useParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';

import '../assets/custom.css'
import Menubar from './Partial/Menubar';

export default function Product() {
    const option = {
        responsive: {
            0: {
                items: 1.5
            },
            768: {
                items: 4.5
            }
        },
        dots: false,
        loop: true,
        autoplay: true,
        autoplayTimeout: 3000,
        autoplayHoverPause: true,
        smartSpeed: 900,
        fluidSpeed: true,
        nav: true,
        navText: ['<i class="fa fa-arrow-left text-info px-3 py-1 border-1 border-dark rounded"></i>', '<i class="fa fa-arrow-right text-info px-3 py-1"></i>']
    }

    let [product, setProduct] = useState({ pic: [] })
    let [relatedProduct, SetRelatedProduct] = useState([])
    let [qty, setQty] = useState(1)
    let [cart, setCart] = useState([])
    let [wishlist, setWishlist] = useState([])

    let { _id } = useParams()
    let dispatch = useDispatch()
    let navigate = useNavigate()

    let ProductStateData = useSelector(state => state.ProductStateData)
    let CartStateData = useSelector(state => state.CartStateData)
    let WishlistStateData = useSelector(state => state.WishlistStateData)

    function addTocard() {
        const userId = localStorage.getItem("userid");
        if (!userId) {
            toast.error("You need to login to add items to the cart.", {
                position: "bottom-right",
                autoClose: 3000,
                onClose: () => navigate('/login'),
            });
            return;
        }
        let item = cart.find((x) => x.user === userId && x.product === _id)
        if (!item) {
            item = {
                user: userId,
                product: _id,
                qty: qty,
                total: product.finalPrice * qty,
            }

            dispatch(createCart({ ...item }))
            toast.success("Product Added In Cart!", {
                position: "bottom-right",
                autoClose: 3000,
            });
        }
        navigate('/cart')
    }

    function addTowishlist() {
        const userId = localStorage.getItem("userid");
        if (!userId) {
            toast.error("You need to login to add items to the wishlist.", {
                position: "bottom-right",
                autoClose: 3000,
                onClose: () => navigate('/login'),
            });
            return;
        }

        let item = wishlist.find((x) => x.user === userId && x.product === _id);
        if (!item) {
            item = {
                user: userId,
                product: _id,
            };
            dispatch(createWishlist({ ...item }));
            toast.success("Product Added to Wishlist!", {
                position: "bottom-right",
                autoClose: 3000,
            });
        }
        navigate('/wishlist');
    }


    useEffect(() => {
        (() => {
            dispatch(getProduct())
            if (ProductStateData.length) {
                let item = ProductStateData.find((x) => x._id === _id)
                setProduct(item)
                SetRelatedProduct(ProductStateData.filter((x) => x.maincategory?._id === item.maincategory?._id))
            }
        })()
    }, [ProductStateData.length, _id])

    useEffect(() => {
        (() => {
            dispatch(getCart())
            if (CartStateData.length)
                setCart(CartStateData)
        })()
    }, [CartStateData.length])

    useEffect(() => {
        (() => {
            dispatch(getWishlist())
            if (WishlistStateData.length)
                setWishlist(WishlistStateData)
        })()
    }, [WishlistStateData.length])

    return (
        <>
            <Menubar />
            <div className="container-fluid mt-3">
                <div className="container">
                    <div className="row g-4 mb-3">
                        <div className="col-lg-12 col-xl-10">
                            <div className="row g-4">
                                <div className="col-lg-6">
                                    <div className="rounded">
                                        <div id="carouselExampleIndicators" className="carousel slide">
                                            <div className="carousel-indicators">
                                                <button type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to="0" className="active" aria-current="true" aria-label="Slide 1"></button>
                                                {
                                                    product.pic.slice(1).map((item, index) => {
                                                        return <button key={product._id} type="button" data-bs-target="#carouselExampleIndicators" data-bs-slide-to={index + 1} aria-label={`Slide ${index + 1}`}></button>
                                                    })
                                                }
                                            </div>
                                            <div className="carousel-inner">
                                                <div className="carousel-item active">
                                                    <img src={`/${product.pic[0]}`} height={450} width="100%" className="d-block w-100 rounded" alt="..." />
                                                </div>
                                                {
                                                    product.pic.slice(1).map((item) => {
                                                        return <div key={product._id} className="carousel-item">
                                                            <img src={`/${item}`} height={450} width="100%" className="d-block w-100 rounded" alt="..." />
                                                        </div>
                                                    })
                                                }
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className="col-lg-6">
                                    <h4 className="fw-bold mb-3">{product?.name}</h4>
                                    <table className='table'>
                                        <tbody>
                                            <tr>
                                                <th>Maincategory</th>
                                                <td>{product.maincategory?.name}</td>
                                            </tr>
                                            <tr>
                                                <th>Subcategory</th>
                                                <td>{product.subcategory?.name}</td>
                                            </tr>
                                            <tr>
                                                <th>Brand</th>
                                                <td>{product.brand?.name}</td>
                                            </tr>
                                            <tr>
                                                <th>Color/Size</th>
                                                <td>{product.color}/{product.size}</td>
                                            </tr>
                                            <tr>
                                                <th>Stock</th>
                                                <td>{product.stock ? `Yes /${product.stockQuantity} Left in Stock` : "Out of stock"}</td>
                                            </tr>
                                            <tr>
                                                <th>Fare Price</th>
                                                <td>&#8377;<del className='text-danger'>{product.basePrice}</del></td>
                                            </tr>
                                            <tr>
                                                <th>Discount Price</th>
                                                <td>&#8377;{product.finalPrice} <sup>{product.discount}% off</sup></td>
                                            </tr>
                                        </tbody>
                                    </table>
                                    {
                                        product.stock ?
                                            <>
                                                <div className="input-group quantity mb-4" style={{ width: "100px" }}>
                                                    <div className="input-group-btn">
                                                        <button onClick={() => qty > 1 ? setQty(qty - 1) : ""} className="btn btn-sm btn-minus rounded-circle bg-light border" >
                                                            <i className="fa fa-minus"></i>
                                                        </button>
                                                    </div>
                                                    <input type="text" className="form-control form-control-sm text-center rounded mx-1" value={qty} />
                                                    <div className="input-group-btn">
                                                        <button onClick={() => qty < product.stockQuantity ? setQty(qty + 1) : ""} className="btn btn-sm btn-plus rounded-circle bg-light border">
                                                            <i className="fa fa-plus"></i>
                                                        </button>
                                                    </div>
                                                </div>
                                                <div className='d-flex'>
                                                    <Link to="/cart" onClick={addTocard} className="add btn border btn-info rounded-pill mx-2 px-4 py-2 mb-4 w-50"><i className="fa fa-shopping-bag me-2 text-[#000]"></i> Add To Cart</Link>
                                                    <Link to="/wishlist" onClick={addTowishlist} className="add btn border rounded-pill mx-2 px-4 py-2 mb-4 btn-success w-50"><i className="fa fa-heart me-2 text-white"></i> Add To Wishlist</Link>
                                                </div>
                                            </> :
                                            <div className='d-flex'>
                                                <Link to="/wishlist" onClick={addTowishlist} className="add btn border rounded-pill mx-2 px-4 py-2 mb-4 btn-success w-50"><i className="fa fa-heart me-2 text-white"></i> Add To Wishlist</Link>
                                            </div>
                                    }
                                </div>
                                <div className="col-lg-12 mt-1">
                                    <nav>
                                        <div className="nav nav-tabs mb-3">
                                            <button className="nav-link text-dark active" type="button" role="tab"
                                                id="nav-about-tab" data-bs-toggle="tab" data-bs-target="#nav-about"
                                                aria-controls="nav-about" aria-selected="true">Description</button>
                                            <button className="nav-link text-dark" type="button" role="tab"
                                                id="nav-mission-tab" data-bs-toggle="tab" data-bs-target="#nav-mission"
                                                aria-controls="nav-mission" aria-selected="false">Reviews</button>
                                        </div>
                                    </nav>
                                    <div className="tab-content">
                                        <div className="tab-pane active" id="nav-about" role="tabpanel" aria-labelledby="nav-about-tab">
                                            <p dangerouslySetInnerHTML={{ __html: product?.discription }} />
                                        </div>
                                        {/* <div className="tab-pane" id="nav-mission" role="tabpanel" aria-labelledby="nav-mission-tab">
                                            <div className="d-flex">
                                                <img src="img/avatar.jpg" className="img-fluid rounded-circle p-3" style={{ width: "100px", height: "100px" }} alt="" />
                                                /                                         <div className="">
                                                    <p className="mb-2" style={{ fontSize: "14px" }}>April 12, 2024</p>
                                                    <div className="d-flex justify-content-between">
                                                        <h5>Jason Smith</h5>
                                                        <div className="d-flex mb-3">
                                                            <i className="fa fa-star text-info"></i>
                                                            <i className="fa fa-star text-info"></i>
                                                            <i className="fa fa-star text-info"></i>
                                                            <i className="fa fa-star text-info"></i>
                                                            <i className="fa fa-star"></i>
                                                        </div>
                                                    </div>
                                                    <p>The generated Lorem Ipsum is therefore always free from repetition injected humour, or non-characteristic
                                                        words etc. Susp endisse ultricies nisi vel quam suscipit </p>
                                                </div>
                                            </div>
                                            <div className="d-flex">
                                                <img src="img/avatar.jpg" className="img-fluid rounded-circle p-3" style={{ width: "100px", height: "100px" }} alt="" />
                                                /                                         <div className="">
                                                    <p className="mb-2" style={{ fontSize: "14px" }}>April 12, 2024</p>
                                                    <div className="d-flex justify-content-between">
                                                        <h5>Sam Peters</h5>
                                                        <div className="d-flex mb-3">
                                                            <i className="fa fa-star text-info"></i>
                                                            <i className="fa fa-star text-info"></i>
                                                            <i className="fa fa-star text-info"></i>
                                                            <i className="fa fa-star"></i>
                                                            <i className="fa fa-star"></i>
                                                        </div>
                                                    </div>
                                                    <p className="text-dark">The generated Lorem Ipsum is therefore always free from repetition injected humour, or non-characteristic
                                                        words etc. Susp endisse ultricies nisi vel quam suscipit </p>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="tab-pane" id="nav-vision" role="tabpanel">
                                            <p className="text-dark">Tempor erat elitr rebum at clita. Diam dolor diam ipsum et tempor sit. Aliqu diam
                                                amet diam et eos labore. 3</p>
                                            <p className="mb-0">Diam dolor diam ipsum et tempor sit. Aliqu diam amet diam et eos labore.
                                                Clita erat ipsum et lorem et sit</p>
                                        </div> */}
                                    </div>
                                </div>
                                {/* <form action="#">
                                    <h4 className="mb-5 fw-bold">Leave a Reply</h4>
                                    <div className="row g-4">
                                        <div className="col-lg-6">
                                            <div className="border-bottom rounded">
                                                <input type="text" className="form-control border-0 me-4" placeholder="Yur Name *" />
                                            </div>
                                        </div>
                                        <div className="col-lg-6">
                                            <div className="border-bottom rounded">
                                                <input type="email" className="form-control border-0" placeholder="Your Email *" />
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="border-bottom rounded my-4">
                                                <textarea name="" id="" className="form-control border-0" cols="30" rows="8" placeholder="Your Review *" spellcheck="false"></textarea>
                                            </div>
                                        </div>
                                        <div className="col-lg-12">
                                            <div className="d-flex justify-content-between py-3 mb-5">
                                                <div className="d-flex align-items-center">
                                                    <p className="mb-0 me-3">Please rate:</p>
                                                    <div className="d-flex align-items-center" style={{ fontSize: "12px" }}>
                                                        <i className="fa fa-star text-muted"></i>
                                                        <i className="fa fa-star"></i>
                                                        <i className="fa fa-star"></i>
                                                        <i className="fa fa-star"></i>
                                                        <i className="fa fa-star"></i>
                                                    </div>
                                                </div>
                                                <a href="#" className="btn border border-info text-info rounded-pill px-4 py-3"> Post Comment</a>
                                            </div>
                                        </div>
                                    </div>
                                </form> */}
                            </div>
                        </div>
                    </div>
                    <h2 className="fw-bold mb-2">Related Product</h2>
                    <div className="testimonial-carousel justify-content-center">
                        <OwlCarousel className='owl-theme' {...option}>
                            {
                                relatedProduct.length > 0 && relatedProduct.map((item, index) => {
                                    return <div key={index} className="border border-dark me-2 rounded position-relative bg-white">
                                        <div className="vesitable-img">
                                            <img src={`/${item.pic[0]}`} className="related-image img-fluid w-100 rounded-top" alt="" />
                                        </div>
                                        <div className="text-white bg-dark px-2 rounded position-absolute" style={{ top: "10px", left: "10px", fontSize: "14px" }}>{item.brand?.name}</div>
                                        <div className="px-2 pb-0 rounded-bottom">
                                            <Link to={`/product/${item._id}`} className='py-2 mb-2' style={{ fontSize: "1rem" }}>{item.name?.slice(0, 25) + "..."}</Link>
                                            <div className="d-flex gap-2 flex-lg-wrap">
                                                <p>&#8377;<del className='text-danger'>{item.basePrice}</del></p>
                                                <p className={`related extra ${item.stock ? "text-success" : "text-danger"}`}>{item.stock ? `(In Stock / only ${item.stockQuantity} Left)` : "(Out of Stock)"}</p>
                                            </div>
                                            <div className="d-flex gap-4 flex-lg-wrap mb-1">
                                                <p className='finalPrice'>&#8377;{item.finalPrice} <sup>{item.discount}% off</sup></p>
                                                <span><Link to={`/product/${item._id}`} className="related px-3 py-2 rounded-pill bg-info"><i className="fa fa-shopping-bag me-2"></i> Add to cart</Link></span>
                                            </div>
                                        </div>
                                    </div>
                                })
                            }
                        </OwlCarousel>
                    </div>
                </div>
            </div>
        </>
    )
}
